<template>
  <b-modal :id="id" :title="$t('dharma-application-form.title')" centered scrollable size="lg" @shown="showChinaMainlandApplicationNotice">
    <b-alert variant="danger" class="font-weight-bold" show v-if="form_data.delivery.area === 'China Mainland'" v-html="$t('dharma-application-form.application-summary.instruction-text.china-mainland-application-notice')">
    </b-alert>
    <b-alert variant="warning" show>{{ $t('dharma-application-form.application-summary.instruction-text.check-and-confirm') }}</b-alert>
    <section>
      <h5>{{ $t('dharma-application-form.application-list.title') }}</h5>
      <application-list ref="application_list" @update-items="calcTotalOfApplicationItems"></application-list>
    </section>
    <p class="text-danger font-weight-bold">
      {{ $t('dharma-application-form.application-summary.instruction-text.change-application-items') }}
    </p>
    <section>
      <h5>{{ $t('dharma-application-form.applicant.title') }}</h5>
      <p>
        <strong>{{ $t('dharma-application-form.applicant.type-selector.label') }}</strong>
        {{ $t(`dharma-application-form.applicant.type-selector.option.${form_data.type}.label`) }}
      </p>
      <individual-form
        ref="individual_form"
        :form_data="form_data"
        :is_bulk_application="total_of_application_items > 500"
        v-if="form_data.type === 'individual'"
      ></individual-form>
      <group-form
        ref="group_form"
        :form_data="form_data"
        :is_bulk_application="total_of_application_items > 500"
        v-if="form_data.type === 'group'"
      ></group-form>
      <proxy-form
        ref="proxy_form"
        :form_data="form_data"
        :is_bulk_application="total_of_application_items > 500"
        v-if="form_data.type === 'proxy'"
      ></proxy-form>
    </section>
    <template #modal-footer="{ close }">
      <b-button
        class="w-50"
        variant="default"
        @click="close"
        v-html="$t('dharma-application-form.application-summary.button.give-up.label')"
      ></b-button>
      <b-button
        class="w-50"
        variant="success"
        @click="submit"
        :disabled="submitting"
      >
        <b-spinner small v-if="submitting"></b-spinner>
        {{ submitting ? $t('modal.button.submitting.label') : $t('modal.button.submit.label') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'

import { AlertPlugin, SpinnerPlugin } from 'bootstrap-vue'

import DharmaApplicationOrderApiService from '@/services/budaedu-api-services/dharma-application-order-api-service.js'

import ApplicationList from '../ApplicationList.vue'
import IndividualForm from '../IndividualForm.vue'
import GroupForm from '../GroupForm.vue'
import ProxyForm from '../ProxyForm.vue'

Vue.use(AlertPlugin)
Vue.use(SpinnerPlugin)
Vue.use(VueLocalStorage)

Vue.use(DharmaApplicationOrderApiService)

export default {
  name: 'application-summary-modal',
  props: {
    id: {
      type: String,
      required: true,
    },
    form_data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      total_of_application_items: 0,
      submitting: false
    }
  },
  computed: {
    validation_schema() {
      return {
        field: {
          type: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.error-message.type.required'),
            },
          ],
        },
      };
    }
  },
  methods: {
    calcTotalOfApplicationItems(application_items) {
      this.total_of_application_items = application_items.reduce((sum, item) => sum + parseInt(item.quantity), 0);
    },
    async submit() {
      if (this.submitting) return;
      this.submitting = true;

      try {
        const application_list = this.$refs['application_list']
        const applicant_form = this.$refs[`${this.form_data.type}_form`]
        const application_list_validation_result = await application_list.validateForm()
        const applicant_form_validation_result = await applicant_form.validateForm()
        
        if (application_list_validation_result && applicant_form_validation_result) {
          const cleanObject = (obj) => {
            const new_obj = {};
            for (const key in obj) {
              if (obj[key] !== null && obj[key] !== '') {
                new_obj[key] = obj[key];
              }
            }
            return new_obj;
          };

          let data = {
            type: this.form_data.type,
            applicants: [],
            application_items: application_list.items,
            delivery: cleanObject(applicant_form.delivery)
          }

          if (application_list.purpose) {
            data.purpose = application_list.purpose
          }
          if (application_list.purpose_detail) {
            data.purpose_detail = application_list.purpose_detail
          }

          if (this.form_data.type == 'proxy') {
            data.applicants.push(cleanObject(applicant_form.$refs['principal_form'].applicant));
            data.applicants.push(cleanObject(applicant_form.$refs['agent_form'].applicant));
          } else {
            data.applicants.push(cleanObject(applicant_form.applicant));
          }
          
          // console.log(data)
          await this.$dharmaApplicationOrderApiService.create(data)
          this.$localStorage.set('application-items', JSON.stringify([]))
          this.$localStorage.set('application-purpose', '')
          this.$localStorage.set('application-purpose-detail', '')
          
          this.$emit('submit', data)
          this.$bvModal.hide(this.id)
        }
      } finally {
        this.submitting = false;
      }
    },
    showChinaMainlandApplicationNotice() {
      if (this.form_data.delivery.area === 'China Mainland') {
        const h = this.$createElement
        this.$bvModal.msgBoxOk(
          h('div', { domProps: { innerHTML: this.$t('dharma-application-form.application-summary.instruction-text.china-mainland-application-notice') } }),
          {
            title: this.$t('dharma-application-form.application-summary.modal.china-mainland-application-notice.title'),
            okTitle: this.$t('dharma-application-form.application-summary.modal.china-mainland-application-notice.button.ok.label'),
            centered: true
          }
        )
      }
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    ApplicationList,
    IndividualForm,
    GroupForm,
    ProxyForm,
  }
};
</script>
